<template lang="html">
  <div class="md-card md-table table-630 md-theme-default CustomTable" md-card>
    <div class="md-toolbar md-table-toolbar md-transparent md-theme-default md-elevation-0">
      <div class="md-toolbar-section-start">
        <div class="w-100">
          <div class="d-flex w-100 align-items-center justify-content-between ">
            <div class="d-flex align items-center  ">
              <h5><b>{{ $t('threshold.sensorList') }}</b></h5>
              <p v-if="loadingData" class="loading-container">
                <b-spinner variant="primary" label="Spinning" />
              </p>
            </div>
            <div class=" " v-if="isGolfCourse">
              <button class="btn btn-link" v-text=" ( showFilters ? $t('threshold.hideFilter') : $t('threshold.showFilter') )" @click=" showFilters = !showFilters "> </button>
            </div>
          </div>
          <div class="row filter-section" v-if="isGolfCourse && showFilters">
            <div class="col-6">
              <md-field class=" d-flex flex-column p-0">
              <span class="my-2">{{ $t('threshold.holeRange') }}</span>
                <md-select v-model="tempRanges" :placeholder="$t('general.select')" md-dense multiple @input="changeFilters()">
                  <md-option :value="index" v-for="(range, index) in ranges" :key="index"> {{range.label}} </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="col-6">
              <md-field class="d-flex flex-column p-0">
              <span class="my-2">{{ $t('sensors.location') }}</span>
                <md-select v-model="tempLocations" id="locaiton" :placeholder="$t('general.select')" md-dense multiple @input="changeFilters()">
                  <md-option :value="index" v-for="(zone,index) in zones" :key="zone.zone_id"> {{zone.name}} </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="md-table-fixed-header">
        <div class="md-table-fixed-header-container">
          <table>
            <thead>
              <tr id="content-columns">
                <th class="md-table-head md-table-cell-selection">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">
                      <div class="md-table-cell-container">
                        <md-checkbox v-model="all" @change="onClick($event, -1)" />
                      </div>
                    </div>
                  </div>
                </th>
                <th class="md-table-head md-numeric">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div v-if="isGolfCourse" class="md-table-head-label " > {{ $t('general.all') }}  </div>
                    <div v-else class="md-table-head-label " > {{ $t('general.all') }}  </div>
                  </div>
                </th>
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label"> {{ $t('sensors.sensor') }} </div>
                  </div>
                </th>
                <th class="md-table-head">
                  <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label"> {{ $t('sensors.location') }} </div>
                  </div>
                </th>
              </tr>
              
            </thead>
          </table>
        </div>
      </div>
      <div class="md-content md-table-content md-scrollbar md-theme-default">
        <table height="">
          <tbody id="content-rows">
            <tr v-show="rows.length" class="md-table-row md-has-selection" :class="{'md-selected': row.selected}"
              v-for="(row, index) in rows" :key="index" @click="onClick(!row.selected, index)">
              <td class="md-table-cell md-table-cell-selection">
                <div class="md-table-cell-container">
                  <md-checkbox v-model="row.selected" @change="onClick($event, index)" />
                </div>
              </td>
              <td class="md-table-cell">
                <div class="md-table-cell-container">
                  {{ G_getHoleNumber({ hole:row.hole, includeLbl:false }) }}
                </div>
              </td>
              <td class="md-table-cell">
                <div class="md-table-cell-container">{{ G_getSensorName({sensor: row, lbl: false, code: false}) }}</div>
              </td>
              <td class="md-table-cell">
                <div class="md-table-cell-container">
                  {{ isGolfCourse ? G_getSensorLocation({ sensor: row }) : G_getZoneName({ zone: row.hole }) }}
                </div>
              </td>
            </tr>
            <tr v-show="!rows.length" class="no-data">
              <td class="md-table-cell text-center" colspan="4">
                <p class="text-center py-4">
                  <span class="my-5" v-text="loadingData ? $t('general.searching') : $t('holes.noData')" ></span> 
                </p> 
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>
  import {
    inRange,
    union,
    max,
    min,
  } from 'lodash';

  export default {
    name: 'CustomTable',
    props: {
      loadingData:{
        type: Boolean,
      },
      rows: {
        type: Array,
        required: false,
        default: () => [],
      },
      zones: {
        type: Array,
        required: false,
        default: () => [],
      },
      ranges: {
        type: Array,
        required: false,
        default: () => [],
      },
      setAll: {
        type: Function,
        required: false,
        default: () => {},
      },
      onSelect: {
        type: Function,
        required: false,
        default: () => {},
      },
      filterSensors: {
        type: Function,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        all: false,
        showFilters: true,
        tempRanges: [],
        tempLocations: [],
        isGolfCourse: false
      };
    },
    methods: {
      changeFilters(){
        let tempRanges = union(...this.tempRanges.map((index) => this.ranges[index].range));
        let zoneIds = this.tempLocations.map((index) => this.zones[index].zone_id);
        this.filterSensors(zoneIds , tempRanges);
      },
      onClick(ev, index) {
        if (index > -1) {
          this.rows[index].selected = ev;
          if (this.all) {
            this.all = false;
          }
          this.onSelect(this.rows.filter((r) => r.selected));
        } else {
          this.setAll(ev);
          if (ev) {
            this.onSelect(this.rows.map((r) => r));
          } else {
            this.onSelect([]);
          }
        }
      },
      resize() {
        const body = document.querySelector('#content-rows');
        const head = document.querySelector('#content-columns');
        if (body && body.children[0]) {
          Array.prototype.forEach.call(body.children[0].children, (td, index) => {
            head.children[index].style.width = `${td.offsetWidth}px`;
          });
        }
      },
    },
    watch: {
      rows() {
        setTimeout(() => {
          this.resize();
        }, 100);
      },
    },
    mounted() {
      if (this.rows.length) {
        this.resize();
      }
      window.addEventListener('resize', () => {
        if (this.rows.length) {
          this.resize();
        }
      });
      this.isGolfCourse = 
        ( (this.$store.state.course.facility_type && this.$store.state.course.facility_type.is_golf_course) || !this.$store.state.course.facility_type)
          ? true : false;
    },
  };

</script>
<style lang="scss">

.md-field.md-theme-default:before{
  background: none;
}
.md-field::after{
   height: 0px;
}
.md-field{
  label{
    margin-left: 1rem;
  }
 }
 .md-select-menu{
   margin-top: 3rem;
   margin-left: 1rem;
 }
.md-select{
  padding-left: 1rem;
  background-color: white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid lightgray;
}
.filter-section{
  border-top:  1px solid #E8E8E8 ;
  border-bottom:  1px solid #E8E8E8 ;
}
</style>